import { render, staticRenderFns } from "./DropdownType.vue?vue&type=template&id=6ddc98b9&"
import script from "./DropdownType.vue?vue&type=script&lang=js&"
export * from "./DropdownType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports